// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".details-card {\n  padding: 24px;\n}\n.details-card .details-title {\n  color: #0E6488;\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
